import { RootStateType } from '../../store';

export function selectToasts(state: RootStateType) {
  return state.toasts.toasts;
}

export function selectVisibleToasts(state: RootStateType) {
  return state.toasts.toasts.filter((t) => !t.isDismissed);
}
